<template>
    <div data-card-management-component>
        <input
            type="hidden"
            name="saved-card-status"
            :value="savedCardStatus"
        />
        <div v-if="loading && !noSpinner"><wait-comp></wait-comp></div>
        <div v-else-if="cardRequired !== true">
            <input type="hidden" value="User has already card saved." />
        </div>
        <div v-else>
            <input type="hidden" value="User has no card. Card is required." />
        </div>
        <forced-top-element immediate v-if="showPopup">
            <modal-dialog
                @close-dialog="closedPopup()"
                immediate
                ref="dialog"
                :class="$style['modal-dialog']"
                auto-open
                :closeButton="true"
                :opacity="0.7"
            >
                <card-popup-content
                    :terms-link="termsLink"
                    @cancelled="onCancelled"
                    @card-accepted="onCardAccepted"
                    @card-failed-accept="onCardFailed"
                ></card-popup-content>
            </modal-dialog>
        </forced-top-element>
    </div>
</template>

<style module lang="scss">
@import "common.css.src/mixins.scss";

.card-management-page {
}

.modal-dialog {
    max-height: 95svh;
    width: 95%;
    @include when-desktop() {
        max-height: 640px;
        max-width: 780px;
    }
}

.modal-dialog {
    color: black;
    top: 50svh;
    left: 50vw;
    transform: translate(-50%, -50%);
    position: fixed;
}

.card-items {
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.card-item {
    display: inline-block;
    border-radius: 5px;
    border: 1px solid black;
}

.card-item.card-valid {
    background-color: #c2e0b8;
}

.card-item.card-invalid {
    background-color: #e0b8b8;
}

.issued-to-container {
    display: block;
}

.card-number-container {
    display: block;
}
</style>

<script setup lang="ts">
import cardPopupContent from "./card-popup-content.vue";

import { checkCardIsRequiredForUser } from "../web-api";

import modalDialog from "../../../shared/ModalDialog.vue";
import waitComp from "./wait.vue";
import forcedTopElement from "../../../shared/forced-top-element.vue";
import { computed, getCurrentInstance, onMounted, ref, watch } from "vue";

defineProps({
    termsLink: String,
    noSpinner: Boolean,
});

const cardRequired = ref<boolean>();
const waitingForDialog = ref(false);
const showPopup = ref(false);
const loading = ref(false);
const waitAttempts = ref(0);
const callbacks = ref<(() => void)[]>([]);
const savedCardStatus = computed(() => {
    return cardRequired.value ? "missing" : "ok";
});
const emit = defineEmits(["update:saved-card-status"]);
watch(
    () => savedCardStatus.value,
    (newValue) => {
        emit("update:saved-card-status", newValue);
    },
    {
        immediate: true,
    }
);

async function onCancelled() {
    closePopup();
    await reset();
}
function onCardFailed() {
    alert("Something went wrong");
}
async function onCardAccepted() {
    closePopup();
    await refreshCardIsRequired();
    if (cardRequired.value !== false) {
        alert("Something went wrong");
        throw new Error("Card still required after accept!?");
    }
    callcallbacks();
}

const instance = getCurrentInstance();

function callcallbacks() {
    let callback;
    while ((callback = callbacks.value.shift()) != null) {
        callback();
    }
}
async function reset() {
    cardRequired.value = undefined;
    waitingForDialog.value = false;
    showPopup.value = false;
    loading.value = false;
    waitAttempts.value = 0;
    //callbacks.value = [];
    await refreshCardIsRequired();
}
function openPopup() {
    showPopup.value = true;
}

const dialog = ref<InstanceType<typeof modalDialog>>();
function closePopup() {
    if (dialog.value != null)
        (dialog.value as unknown as { closeDialog(): void }).closeDialog();
}
function closedPopup() {
    showPopup.value = false;
}
async function refreshCardIsRequired() {
    loading.value = true;
    try {
        const response = await checkCardIsRequiredForUser();
        const data = response.data;
        cardRequired.value = data.required;
    } finally {
        loading.value = false;
    }
}

defineExpose({
    openPopup: exposedOpenPopup,
});

function exposedOpenPopup(
    callback: (() => void) | undefined | null = undefined
) {
    if (typeof callback === "function") {
        callbacks.value.splice(0, callbacks.value.length);
        callbacks.value.push(callback);
    }
    openPopup();
}

onMounted(async () => {
    if (instance == null) throw new Error("missing instance");
    // TODO get waitForAcceptOnCard from url
    window.$(instance.proxy.$el).data("openPopup", (callback: () => void) => {
        exposedOpenPopup(callback);
    });
    await refreshCardIsRequired();
});
</script>
